/** Steps項目 */
export const E300_STEPS_ITEMS = [
  { label: '問い合わせ登録' },
  { label: '登録内容確認' },
  { label: '登録完了' },
];
